import { API_PATH_INTERNAL } from '@/lib/constants'
import apiService from '@/lib/services/apiService'
import {
  ClaimReferralInviteRequest,
  PatchReferralInviteRequest,
} from '@/types/requests/referral-invites'

class ReferralInviteService {
  private endpoint = `${API_PATH_INTERNAL}/referral-invites`

  async claimReferralInvite(request: ClaimReferralInviteRequest) {
    const response = await apiService.post(`${this.endpoint}/claim`, request)

    return response.data
  }

  async updateInvite(
    referralInviteId: number,
    request: PatchReferralInviteRequest,
  ) {
    const response = await apiService.patch(
      `${this.endpoint}/${referralInviteId}`,
      request,
    )

    return response.data
  }
}

const referralInviteService = new ReferralInviteService()

export default referralInviteService
